import { EventListenerTarget, } from '../types';
import { onComponent } from './componentEventListener';
import { onPage } from './pageEventListener';
import { onHotArea } from './hotAreaEventListener';
import { onAction } from './actionEventListener';
import { onPlugin } from './pluginEventListener';
export function on(target, eventType, callback) {
    switch (target) {
        case EventListenerTarget.PAGE: {
            return onPage(eventType, callback);
        }
        case EventListenerTarget.COMPONENT: {
            return onComponent(eventType, callback);
        }
        case EventListenerTarget.HOT_AREA: {
            return onHotArea(eventType, callback);
        }
        case EventListenerTarget.PLUGIN: {
            return onPlugin(eventType, callback);
        }
        case EventListenerTarget.ACTION: {
            return onAction(eventType, callback);
        }
        default: {
            throw new Error("Invalid [target] " + target + ", must one of '" + EventListenerTarget.PAGE + "', '" + EventListenerTarget.COMPONENT + "', '" + EventListenerTarget.HOT_AREA + "'");
        }
    }
}
export function withPersistReactEvent(handler) {
    return function (e) {
        e.persist();
        return handler(e);
    };
}
var hocMap = {};
// TODO[R]: TS 类型推导优化
export var wrapHocOnce = function (componentName, Component, hoc) {
    if (!hocMap[componentName]) {
        hocMap[componentName] = hoc(Component);
    }
    return hocMap[componentName];
};
export var clearHocMap = function () {
    hocMap = {};
};
export * from './actionHandler';
export * from './pageEventListener';
export * from './componentEventListener';
export * from './hotAreaEventListener';
export * from './actionParams';
export * from './eventEmiter';
export * from './eventProxy';
export * from './componentEventActionEmitter';
export * from './customEventTrigger';
export * from './emitComponentEvent';
export * from './simulateEventRegister';
//# sourceMappingURL=index.js.map